import React from "react"
import { Row, Col, Container } from "react-bootstrap"
const DescriptionSection = () => {
  return (
    <section id="description">
      <Container className="container">
        <Row>
          <Col md={6} className=" decs-col-1">
            <p>
              Rehab Find is on a mission to make Canada and the world at large a
              better place. By providing access to a multitude of rehab services
              across the nation, we aim to help people who struggle with
              addiction achieve a healthy and sober life. <br /> Addiction is
              indeed a very challenging concern and it is a complex issue to be
              dealt with. Rehabilitation is not a one-day process but can be a
              lifelong journey. Thus, Rehab Find believes that the people who
              choose to fight addiction, together with friends, family and
              people that support them, are heroes in every sense of the word.
            </p>
          </Col>
          <Col md={6} className=" my-auto decs-col-2">
            <p>
              For that reason, Rehab Find’s objective is to offer a wide variety
              of educational resources and tools that would help in achieving
              the goal of recovering from addiction.
              <br /> Addiction is a complex and challenging beast, and
              rehabilitation can be a lifelong journey. We fully believe that
              the people who choose to fight addiction, as well as the friends
              and family who support them, are true heroes in every sense of the
              word. They deserve to have every available resource at their
              disposal, and it’s our mission to make those resources accessible.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default DescriptionSection
